export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-chord/src/array.js
// module id = 1270
// module chunks = 0